import { Timings } from '../../../timings/timings/index.js';
import { Easing } from '../../../easing/easing/index.js';

/**
 * Generates styles for placeholder elements with transition effects.
 *
 * @param placeholderColor - A string representing the color to apply to the placeholder text.
 * @returns An object of type `PlaceholderStylesType` containing the `::placeholder` CSS styles.
 *
 * ### Example
 * ```typescript
 * import { placeholders } from './placeholders';
 *
 * const styles = placeholders('#ccc');
 * // Result:
 * // {
 * //   '&::placeholder': {
 * //     color: '#ccc',
 * //     transition: 'color 300ms ease',
 * //   },
 * // }
 * ```
 */
const placeholders = placeholderColor => ({
    '&::placeholder': {
        color: placeholderColor,
        transition: `color ${Timings.default} ${Easing.ease}`,
    },
});
/**
 * Represents a CSS selector for the `:placeholder-shown` pseudo-class.
 *
 * This is used to target form inputs where the placeholder text is visible.
 * The type `PlaceHolderShownStylesType` ensures compatibility with styling utilities.
 *
 * ### Example
 * ```typescript
 * import { placeholderShown } from './placeholders';
 *
 * const selector = placeholderShown;
 * // Result:
 * // '&:placeholder-shown'
 * ```
 */
const placeholderShown = '&:placeholder-shown';

export { placeholderShown, placeholders };
